<template>
  <el-dialog
    :title="'Edit: ' + file.name"
    :visible.sync="visible"
    width="90%"
    top="5vh"
    :close-on-click-modal="false"
    @close="$emit('close')"
  >
    <div v-loading="loadingContent" class="drive-text-edit-body">
      <textarea
        v-if="!loadingContent && !loadError"
        ref="editorArea"
        :id="editorId"
        style="width: 100%; min-height: 300px;"
      ></textarea>
      <div v-if="loadError" class="drive-text-edit-error">
        <i class="fa fa-exclamation-triangle"></i> {{ loadError }}
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">Cancel</el-button>
      <el-button type="primary" :disabled="loadingContent || !!loadError" @click="onSave">Save</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getApiBase, safeSetXhrHeaders } from "../../global.js";
// Register CKEditor timestamp plugin (idempotent)
if (typeof CKEDITOR !== "undefined" && !CKEDITOR.plugins.registered.inserttimestamp) {
  CKEDITOR.plugins.add("inserttimestamp", {
    init: function (editor) {
      editor.addCommand("insertTimestamp", {
        exec: function (ed) {
          var now = new Date();
          var ts = ("0" + (now.getMonth() + 1)).slice(-2) + "/" +
            ("0" + now.getDate()).slice(-2) + "/" +
            now.getFullYear() + " " +
            ("0" + now.getHours()).slice(-2) + ":" +
            ("0" + now.getMinutes()).slice(-2) + ":" +
            ("0" + now.getSeconds()).slice(-2);
          ed.insertHtml("<strong>[" + ts + "]</strong>&nbsp;");
        }
      });
      editor.ui.addButton("InsertTimestamp", {
        label: "Insert Date/Time",
        command: "insertTimestamp",
        toolbar: "insert",
        icon: "about:blank"
      });
    }
  });
}

export default {
  name: "DriveTextEditDialog",
  props: {
    file: { type: Object, required: true },
    apiHeaders: { type: Object, required: true },
  },
  data: function () {
    return {
      visible: true,
      loadingContent: true,
      loadError: null,
      editorInstance: null,
      editorId: "drive-text-editor-" + Date.now(),
    };
  },
  created: function () {
    this.fetchContent();
  },
  beforeDestroy: function () {
    if (this.editorInstance) {
      try { this.editorInstance.destroy(); } catch (e) { /* noop */ }
      this.editorInstance = null;
    }
  },
  methods: {
    fetchContent: function () {
      var self = this;
      this.loadingContent = true;
      this.loadError = null;

      var baseUrl = getApiBase();
      var url = baseUrl + "drive/files/" + encodeURIComponent(this.file.id) + "/download";

      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "text";
      var headers = this.apiHeaders;
      safeSetXhrHeaders(xhr, headers);

      xhr.onload = function () {
        self.loadingContent = false;
        if (xhr.status === 200) {
          self.initEditor(xhr.response || "");
        } else {
          self.loadError = "Failed to load file content";
        }
      };
      xhr.onerror = function () {
        self.loadingContent = false;
        self.loadError = "Failed to load file content";
      };
      xhr.send();
    },
    initEditor: function (content) {
      var self = this;
      self.$nextTick(function () {
        if (typeof CKEDITOR !== "undefined") {
          self.editorInstance = CKEDITOR.replace(self.editorId, {
            height: "60vh",
            extraPlugins: "inserttimestamp",
            toolbarGroups: [
              { name: "clipboard", groups: ["clipboard", "undo"] },
              { name: "basicstyles", groups: ["basicstyles", "cleanup"] },
              { name: "paragraph", groups: ["list", "indent", "blocks", "align"] },
              { name: "links" },
              { name: "insert" },
              { name: "styles" },
              { name: "colors" },
              { name: "tools" },
            ],
            removeButtons: "Cut,Copy,Paste,Anchor,Subscript,Superscript",
          });
          self.editorInstance.setData(content);
        }
      });
    },
    onSave: function () {
      if (!this.editorInstance) return;
      var html = this.editorInstance.getData();
      this.$emit("save", {
        fileId: this.file.id,
        content: html,
        content_base64: btoa(unescape(encodeURIComponent(html))),
      });
    },
  },
};
</script>

<style scoped>
.drive-text-edit-body {
  min-height: 300px;
}
.drive-text-edit-error {
  text-align: center;
  color: #c0392b;
  padding: 40px;
  font-size: 14px;
}
</style>
<style>
.cke_button__inserttimestamp .cke_button_icon {
  background-image: none !important;
  font-family: FontAwesome !important;
  font-size: 16px !important;
  line-height: 16px !important;
  display: inline-block !important;
}
.cke_button__inserttimestamp .cke_button_icon::after {
  content: "\f017";
  color: #2e7d32;
  font-size: 16px;
}
</style>
